import LoadingButton from "@mui/lab/LoadingButton";
import { TableRow, TableCell, Box, Button, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { ValidatedTextfield } from "./ValidatedTextField";
import { useTranslation } from "@refinedev/core";

type EditablePriceRowProps = {
  isLoading: boolean;
  onClose: () => void;
  onSave: () => void;
  editDesi?: boolean;
};

export const EditablePriceRow = (props: EditablePriceRowProps) => {
  const { isLoading, onClose, onSave, editDesi } = props;
  const {
    getValues,
    formState: { isDirty, isValid },
  } = useFormContext();

  const { translate } = useTranslation();
  const desi = getValues("desi");

  return (
    <TableRow sx={{ height: "75px" }}>
      <TableCell align="center">
        {editDesi ? (
          <ValidatedTextfield name="desi" />
        ) : (
          <Typography>{desi}</Typography>
        )}
      </TableCell>
      <TableCell align="center">
        <ValidatedTextfield name="price" startAdornment="$" />
      </TableCell>

      <TableCell align="center">
        <Box display="flex" justifyContent="center">
          <LoadingButton
            loading={isLoading}
            size="small"
            color="primary"
            variant="contained"
            sx={{ marginRight: "8px" }}
            onClick={onSave}
            disabled={!isDirty || !isValid}
          >
            {translate("buttons.save")}
          </LoadingButton>
          <Button
            disabled={isLoading}
            size="small"
            color="error"
            variant="contained"
            onClick={onClose}
          >
            {translate("buttons.cancel")}
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
};
